<script async setup lang="ts">
import type { IAccoItem } from '@/composables/interfaces/apiInterfaces'
import AccoItemRating from './AccoItemRating.vue'

const props = defineProps<{
  item: IAccoItem
}>()
</script>

<template>
  <div class="relative w-full hover:text-inherit hover:no-underline md:w-1/2">
    <div class="pui-acco-card flex h-full max-h-44 flex-row overflow-hidden !rounded border border-[var(--p-inputtext-border-color)]">
      <div class="relative w-2/5">
        <div class="h-full overflow-hidden">
          <img class="aspect-video h-full w-full object-cover" :alt="props.item.companyName" :src="props.item.img" />
        </div>
      </div>
      <div class="relative w-3/5 items-center gap-1 p-3 leading-5">
        <AccoItemRating :is-superior="props.item.isSuperior" :rating="props.item.rating" :symbol-class="props.item.symbolClass" />
        <div class="mb-0 text-lg font-bold">{{ props.item.companyName }}</div>
        <div class="mt-1 text-sm font-normal">{{ props.item.location }}</div>
      </div>
    </div>
  </div>
</template>
